<template>
    <div>
        <div class="expression" v-if="expressionMedia || expressionText">
            <media :source="expressionMedia" class="expression-media"
                   height="auto" v-if="expressionMedia" width="100%"/>
            <p class="expression-text" v-if="expressionText">{{ expressionText }}</p>
        </div>
    </div>
</template>
<script>
    import PageComponentTemplate from '../page-component-template'
    import Media from '@/components/media'

    export default {
        name: 'page-component-text',
        extends: PageComponentTemplate,
        components: {
            Media
        },
        computed: {
            expressionMedia() {
                if (!this.options || !this.options.hasOwnProperty('expressionMedia')) {
                    return null
                }

                return this.options.expressionMedia
            },
            expressionText() {
                if (!this.options || !this.options.hasOwnProperty('expressionText')) {
                    return null
                }

                return this.options.expressionText
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/font-sizes.less";

    .expression {
        margin-top: 30px;
        text-align: center;

        .expression-media.media-container-image {
            margin-bottom: 50px;
        }

        .expression-text {
            clear: both;
            font-size: @app-font-size-expression;
            margin-top: -50px;
        }
    }
</style>